<template>
  <div class="wt-menu-slider wt2-sg -custom-css">
    <wt-radio-line
      :label="field.label"
      :value="sliderValue"
      :buttons="buttons"
      :disabled="field.disabled"
      @select="changeSliderValue"
    >
      <div class="-menu-slider-header" slot="header">
        <div class="-label-box" v-if="field.label">
          <span>{{ field.label }}</span>
        </div>
        <slot name="tooltip"></slot>
      </div>
    </wt-radio-line>
  </div>
</template>

<script>
import fieldsMixin from '../mixins/fields.vue';

export default {
  props: {
    field: {
      type: Object,
      required: true,
      validator(value) {
        return _.every(['optionThumbnails', 'defaultValue'], (prop) =>
          _.includes(_.keys(value), prop)
        );
      },
    },
  },

  mixins: [fieldsMixin],

  data() {
    return {
      sliderValue: null,
    };
  },

  created() {
    this.sliderValue = _.isDefined(this.field.value)
      ? this.field.value
      : this.field.defaultValue ||
        (this.field.optionThumbnails &&
          this.field.optionThumbnails.length &&
          this.field.optionThumbnails[0].id);

    this.emitChange({ newValue: this.sliderValue, makeDirty: false });

    this.$watch('sliderValue', (newValue) => {
      this.emitChange({ newValue });
    });
  },

  mounted() {
    this.fieldReadyNextTick();
  },

  methods: {
    changeSliderValue(sliderValue) {
      this.sliderValue = sliderValue;
    },
  },

  computed: {
    buttons() {
      return _(this.field.optionThumbnails)
        .map((button) => {
          return {
            text: button.label || button.id,
            value: button.id,
            icon: null,
          };
        })
        .value();
    },
  },
};
</script>
